module.exports = __webpack_public_path__ + "static/media/projects_image.f7964c6b.svg";